/**
 * Retourne le nombre de jours dans le mois actuel.
 *
 * @return {number} Le nombre de jours dans le mois actuel.
 */
export default function() {
    const dateActuelle = new Date();
    return new Date(dateActuelle.getFullYear(), dateActuelle.getMonth() + 1, 0).getDate();
};
